import React, { Suspense } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const SearchKidsComponent = React.lazy(() => import('./components/SearchKids'));

const SearchKids = () => {
  const { searchKey } = useParams();
  const { pathname } = useLocation();

  return (
    <>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <SearchKidsComponent 
          searchKey={searchKey} 
        />
      </Suspense>
    </>
  );
}

export default SearchKids;